import styled from 'styled-components';

export const PostedAt = styled.time`
  color: ${({ theme }) => theme.colors.iconGray};
  display: block;
  font: italic 400 11px/20px ${({ theme }) => theme.fonts.fontFamily};
`;
